import {
  getApiV1ThreeLetterCodeClientAdminsClientNewslettersId,
  getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsClientNewslettersId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
  id: number;
};

type IUseGetClientNewsletter = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersId200;
};

/**
 * 社内報詳細取得フック
 */
export const useGetClientNewsletter: IUseGetClientNewsletter = ({ threeLetterCode, id }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersIdKey(threeLetterCode, id),
    () => getApiV1ThreeLetterCodeClientAdminsClientNewslettersId(threeLetterCode, id),
    { suspense: true }
  );

  return { data };
};
